import { getLocale, getRawLocale } from '@/navbar/i18n'

export function localiseProperty(_locale: string, propertyRecord?: Record<string, string>, fallback?: string): string | undefined {
  if (!propertyRecord) return fallback
  const locale = _locale.toLowerCase()
  const language = locale.split('-')[0]
  return propertyRecord[locale] ?? propertyRecord[language] ?? fallback ?? propertyRecord['en']
}

/**
 * Look up a localised string from a translations/labels record using the
 * current resolved locale (e.g. `'nb'` for `'nb-NO'`).
 *
 * Use for text properties such as labels, where
 * only base-language keys exist.
 */
export function localiseLabel(propertyRecord?: Record<string, string>, fallback?: string): string | undefined {
  return localiseProperty(getLocale(), propertyRecord, fallback)
}

/**
 * Look up a localised URL from a marketing URLs record using the full raw
 * locale as originally provided (e.g. `'en-au'`), before resolution to a
 * supported translation locale.
 *
 * Use for marketing data URL records, where regional variants exist even when
 * translations don't differ (e.g. `en` vs `en-au`).
 */
export function localiseMarketingUrl(propertyRecord?: Record<string, string>): string | undefined {
  return localiseProperty(getRawLocale(), propertyRecord)
}
